export default function validation(response, messages) {
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message !== null) {
      if (message.indexOf('CONTRAT_NATURE_ONLY_ONE_VALEUR_PAR_DEFAUT') === 0) {
        messages.push({
          message: 'addEditContratNature.error.contratNatureOneDefautValue',
        });
      }
    }
  });
}
